<template>
  <v-dialog  width="440px" :value="show" @input="$emit('change-value', $event)">
    <v-card height="280px">
      <v-card-text class="h-100">
        <v-layout row wrap class="h-100">
          <v-flex xs12 class="text-xs-center">
            <span class="title pa-0">
              Lista de espera por canal
            </span>
          </v-flex>
          <v-flex xs12>
            <v-list>
              <template v-for="(item, index) in channels">
                <v-list-tile :key="`channel-${index}`">
                  <v-list-tile-avatar>
                    <v-icon class="k-orange-linear-text">
                      {{icon(item.channel_id)}}
                    </v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{item.name}}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-avatar>
                    {{item.value}}
                  </v-list-tile-avatar>
                </v-list-tile>
                <!-- <v-divider></v-divider> -->
              </template>
            </v-list>
          </v-flex>
          <v-flex>
            <v-layout class="h-100" justify-end align-end>
              <v-btn flat  @click="$emit('change-value', false)">Cerrar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import channelMixins from '@/mixins/channels';

export default {
  mixins: [channelMixins],
  props: {
    show: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      channels: [
        {
          name: 'Email',
          channel_id: 1,
          value: 0,
        },
        {
          name: 'Sms',
          channel_id: 2,
          value: 0,
        },
        {
          name: 'Whatsapp',
          channel_id: 7,
          value: 0,
        },
      ],
    };
  },
  methods: {
    icon(channel) {
      let icon;
      if (channel === 1) {
        icon = 'fas fa-envelope';
      } else if (channel === 7) {
        icon = 'fab fa-whatsapp';
      } else if (channel === 2) {
        icon = 'fas fa-comments';
      }
      return icon;
    },
    updateList(chatCenter) {
      const channel = this.channels.find(x => x.channel_id === chatCenter.channel_id);
      const statusOld = chatCenter.chat_center_status_id_old;
      const statusNew = chatCenter.chat_center_status_id;
      if ([1, 2, 3].includes(statusOld)) {
        channel.quantity -= 1;
      } else if ([1, 2, 3].includes(statusNew)) {
        channel.quantity += 1;
      }
    },
    pusher(dialog) {
      if (dialog) {
        window.Echo.private(`company.${this.$auth.user().company.id}.chatCenter`)
          .listen('.ChatCenterUpdated', (event) => {
            this.updateList(event.chatCenter);
          })
          .listen('.ChatCenterCreated', (event) => {
            this.updateList(event.chatCenter);
          });
      } else {
        window.Echo.leave(`company.${this.$auth.user().company.id}.chatCenter`);
      }
    },
    getInfo() {
      this.axios.get('chats_center/waiting/channel').then(({ data }) => {
        for (let i = 0; i < data.length; i += 1) {
          const channel = this.channels.find(x => x.channel_id === data[i].channel_id);
          channel.value = data[i].total;
        }
      });
    },
  },
  watch: {
    show(show) {
      if (show) {
        this.getInfo();
      }
      this.pusher(show);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/chat_center_v2/WaitingChannel.vue